var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.27 19.0001C10.1377 18.9995 10.0068 18.9727 9.88492 18.9212C9.76305 18.8697 9.6526 18.7946 9.55999 18.7001C9.37374 18.5127 9.26919 18.2593 9.26919 17.9951C9.26919 17.7309 9.37374 17.4774 9.55999 17.2901L14.78 12.0001L9.55999 6.83007C9.46675 6.73552 9.39305 6.62353 9.34309 6.5005C9.29313 6.37746 9.26789 6.24579 9.26882 6.113C9.26975 5.98022 9.29683 5.84891 9.3485 5.72659C9.40017 5.60426 9.47543 5.49331 9.56999 5.40007C9.66454 5.30684 9.77653 5.23313 9.89956 5.18318C10.0226 5.13322 10.1543 5.10798 10.2871 5.10891C10.4198 5.10984 10.5511 5.13691 10.6735 5.18859C10.7958 5.24026 10.9067 5.31552 11 5.41007L16.92 11.3401C17.1062 11.5274 17.2108 11.7809 17.2108 12.0451C17.2108 12.3093 17.1062 12.5627 16.92 12.7501L11 18.6701C10.9076 18.7724 10.7951 18.8546 10.6695 18.9114C10.5439 18.9682 10.4078 18.9984 10.27 19.0001Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.fd8143fc33ede8de1c600f5f209c9fbe.svg";
export { ForwardRef as ReactComponent };